import { render } from "./IntroductionView.vue?vue&type=template&id=80fe187c&scoped=true"
import script from "./IntroductionView.vue?vue&type=script&lang=js"
export * from "./IntroductionView.vue?vue&type=script&lang=js"

import "./IntroductionView.vue?vue&type=style&index=0&id=80fe187c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80fe187c"]])

export default __exports__